module.exports = __webpack_public_path__ + "8ac667692080d968a40253e6e2f567bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/4.png
// module id = 540
// module chunks = 21 54 55 56 77 79 80 88